import { render, staticRenderFns } from "./ZhuantiHome.vue?vue&type=template&id=2083e204&scoped=true"
import script from "./ZhuantiHome.vue?vue&type=script&lang=js"
export * from "./ZhuantiHome.vue?vue&type=script&lang=js"
import style0 from "./ZhuantiHome.vue?vue&type=style&index=0&id=2083e204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083e204",
  null
  
)

export default component.exports